import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../../MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
// namespace SlotGames2 {
export class RoyalChalice2_2Screen extends SlotGameType1_2_2Screen {

}
// }